<script setup>
import PortalShell from '@/Layouts/PortalShell.vue'
</script>

<template>
  <PortalShell portal="driver">
    <slot />
  </PortalShell>
</template>
